import React from "react";
import { NavLink, Outlet, useParams } from "react-router-dom";
import PlaceholderPage from "../../components/PlaceholderPage";
import "../../styles/content.css";

export { default as AdminHome } from "./AdminHome";
export { default as AdminUsers } from "./AdminUsers";
export { default as AdminCharacters } from "./AdminCharacters";
export { default as AdminSettings } from "./AdminSettings";
export { AdminTags, AdminPackages, AdminVip, AdminPromos, AdminModels, AdminGifts } from "./AdminConfig";
export { AdminReports, AdminTopups } from "./AdminReports";

const LINKS = [
  ["/admin", "ภาพรวม", true], ["/admin/users", "ผู้ใช้"], ["/admin/characters", "ตัวละคร"], ["/admin/tags", "แท็ก"], ["/admin/packages", "แพ็กเกจเติมเงิน"], ["/admin/vip", "VIP tiers"],
  ["/admin/promos", "โค้ดโปรโมชัน"], ["/admin/models", "โมเดล AI/ราคา"], ["/admin/gifts", "ของขวัญ"], ["/admin/reports", "รายงาน"], ["/admin/topups", "ยอดเติมเงิน"], ["/admin/settings", "ตั้งค่าระบบ"],
];

export function AdminLayout() {
  return (
    <div>
      <div className="page-head"><div><h1>ผู้ดูแลระบบ</h1><p>เฉพาะ super_user — ทุกการเปลี่ยนแปลงมีผลกับระบบจริง</p></div></div>
      <nav className="admin-nav" aria-label="เมนูผู้ดูแล">{LINKS.map(([to, label, end]) => <NavLink key={to} to={to} end={end} className={({ isActive }) => `chip${isActive ? " is-active" : ""}`}>{label}</NavLink>)}</nav>
      <Outlet />
    </div>
  );
}

export function AdminPlaceholder() {
  const { "*": rest } = useParams();
  return <PlaceholderPage title={`ไม่พบหน้า /admin/${rest || ""}`} todo={["เลือกหน้าจากเมนูด้านบน"]} />;
}
